<template lang="pug">
  LoginComponent
    form(role="form" @submit.prevent="onSignInClick()")
      .field
        label.bold(for="username-input") Username:
        input#username-input.form-field(type="text" v-model="user")
      .field
        label.bold(for="password-input") Password:
        input#password-input.form-field(type="password" v-model="pass")
      slot
      .field
        label.remember
          input(type="checkbox" v-model="rememberMe")
          | remember
        SspActionButton.sign-in-button(type="submit" text="Sign In" :disabled="!isValid" :spinning="loading" )
      .field.text-right
        a.btn.btn-link-cancel(type="button" href="#/security/recoverpassword") forgot password
      .field.notice-box
        .alert.alert-danger(v-if="error") {{error}}
</template>

<script>
import LoginComponent from '@/components/ssp/LoginComponent'
import Auth from '@/service/AuthService'

export default {
  data() {
    return {
      user: null,
      pass: null,
      rememberMe: false,
      msg: this.$route.query.msg && decodeURIComponent(this.$route.query.msg),
      error: null,
      loading: false
    }
  },
  created() {
    Auth.isLoggedIn()
      .then((loggedIn) => {
        if (loggedIn) {
          this.loginSuccessRedirect()
        }
      })
  },
  mounted() {
    this.$el.querySelector('#username-input').focus()
  },
  methods: {
    onSignInClick() {
      this.error = null
      this.loading = true
      Auth.login(this.user, this.pass, this.rememberMe, (loggedIn, resp) => {
        if (!loggedIn) {
          const xAuthError = resp.headers['x-auth-error']
          this.error = this.errorMessage(xAuthError)
          this.$emit('error', resp)
        } else {
          this.loginSuccessRedirect()
        }
        this.loading = false
      })
    },
    loginSuccessRedirect() {
      const redirect = decodeURIComponent(this.$route.query.redirect || '/')
      this.$router.replace(redirect)
    },
    errorMessage(e) {
      switch (e) {
        case 'banned':
          return 'You are banned'
        case 'expired':
          return 'Your account has expired'
        case 'credentials-expired':
          return 'Your credentials have expired'
        case 'locked':
          return 'Your account is locked'
        case 'disabled':
          return 'Your account is disabled'
        case 'null':
          return 'The submitted username and/or password is incorrect'
        default:
          return 'Authentication error'
      }
    }
  },
  watch: {
    user() {
      this.error = null
    },
    pass() {
      this.error = null
    }
  },
  computed: {
    isValid() {
      return this.user && this.pass
    }
  },
  components: { LoginComponent }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue